module.exports = __webpack_public_path__ + "media/integrations/opencart_right-a504f5bf.svg";